import React from "react";
import DemoLandingPage from "./DemoLandingPage";

/**
 * Backward-compatible `/demo/:slug/register` (and `/webinar/:slug/register`)
 * route. Renders the same combined landing page but opens the form view
 * directly.
 */
const DemoRegisterPage = ({ kind = "demo" }) => (
  <DemoLandingPage initialView="register" kind={kind} />
);

export default DemoRegisterPage;
